import { makeStyles, Theme } from '@material-ui/core';

import { CustomStylesProps } from './interfaces';

export const useStyles = makeStyles<Theme, CustomStylesProps>((_theme) => ({
  tableHeadRow: (props) => ({
    background: props.color === 'dark' ? '#717171' : '#f0f0f0',
    position: 'sticky',
    top: 0,
    zIndex: 2
  }),
  tableHeadCell: (props) => ({
    textAlign: props.headerAlign || 'center',
    fontWeight: 'bold'
  }),
  tableRowCell: (props) => ({
    height: '64px',
    padding: '8px',
    width: props.columnWidth || 'auto',
    textAlign: props.cellAlign || 'center'
  }),
  buttonDetail: {
    color: 'green',
    fontWeight: 'bold'
  }
}));
